<div class="container-fluid common-pages-banner">
    <div class="container">
        <div class="tg-theme-heading">
            <h1 class="h1tags">Report a Problem</h1>
        </div>
    </div>
</div>

<div class="container-fluid paddEqual bgGray">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-12 offset-md-3">
                <div class="row rowLeftM">
                    <div class="col-12 pd-0 usersformms">
                        <div class="row marginZero">
                            <div class="col-12">
                                <div class="col-12 usersHeader">
                                    <h4 class="card-title">Send your problem</h4>
                                </div>
                                <form class="col-12 pd-0" [formGroup]="problem" [ngClass]="{'white-layer':problemLoader}" (ngSubmit)="problemEnd()" style="position: relative;">
                                    <div class="alert alert-danger alert-dismissible fade show" *ngIf="problemErrorMsg">
                                        <strong>Error!</strong> {{problemErrorMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="alert alert-success alert-dismissible fade show" *ngIf="problemSuccessMsg">
                                        <strong>Success!</strong> {{problemSuccessMsg}}.
                                        <button type="button" style="background: none;" class="close" data-dismiss="alert">&times;</button>
                                    </div>
                                    <div class="form-group">
                                        <label>Name</label>
                                        <input type="text" class="form-control" required formControlName="name" placeholder="Enter Name" (keypress)="validateAlpha($event)">
                                        <div class="error-msg" *ngIf="problemControl.name.touched && problemControl.name.errors">
                                            <div style="font-size: 12px">Enter name</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Email-Id</label>
                                        <input type="email" class="form-control" required formControlName="email" placeholder="Enter Email Id">
                                        <div class="error-msg" *ngIf="problemControl.email.touched && problemControl.email.errors">
                                            <div style="font-size: 12px">Enter email id</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Phone Number</label>
                                        <input type="tel" class="form-control" required formControlName="phone" placeholder="Enter Phone Number" (keypress)="numberOnly($event,10)">
                                        <div class="error-msg" *ngIf="problemControl.phone.touched && problemControl.phone.errors">
                                            <div style="font-size: 12px">Enter valid phone number</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Subject</label>
                                        <select type="text" class="form-control" required formControlName="option_value">
                                            <option value="">Select subject</option>
                                            <option value="I want to report a problem">I want to report a problem</option>
                                            <option value="I have a suggestion">I have a suggestion</option>
                                            <option value="I want to compliment">I want to compliment</option>
                                            <option value="I Want to join propira">I Want to join propira</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        <div class="error-msg" *ngIf="problemControl.option_value.touched && problemControl.option_value.errors">
                                            <div style="font-size: 12px">Select subject</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>Message</label>
                                        <textarea class="form-control" required formControlName="message" placeholder="Enter Message"></textarea>
                                        <div class="error-msg" *ngIf="problemControl.message.touched && problemControl.message.errors">
                                            <div style="font-size: 12px">Enter message</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <button class="btn btn-danger" type="submit">Submit <div class="box" *ngIf="problemLoader"><div class="loader-13"></div></div></button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>